/* tslint:disable */
/* eslint-disable */
/**
 * Client Signup API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface InvitationContextResponseEnterpriseKpi
 */
export interface InvitationContextResponseEnterpriseKpi {
    /**
     * Whether we display the kpi of the company/organization
     * @type {boolean}
     * @memberof InvitationContextResponseEnterpriseKpi
     */
    displayKpi?: boolean;
    /**
     * 
     * @type {number}
     * @memberof InvitationContextResponseEnterpriseKpi
     */
    ageInYears?: number;
    /**
     * 
     * @type {number}
     * @memberof InvitationContextResponseEnterpriseKpi
     */
    ageInMonths?: number;
    /**
     * 
     * @type {number}
     * @memberof InvitationContextResponseEnterpriseKpi
     */
    nbCompletedMissions?: number;
}

/**
 * Check if a given object implements the InvitationContextResponseEnterpriseKpi interface.
 */
export function instanceOfInvitationContextResponseEnterpriseKpi(value: object): value is InvitationContextResponseEnterpriseKpi {
    return true;
}

export function InvitationContextResponseEnterpriseKpiFromJSON(json: any): InvitationContextResponseEnterpriseKpi {
    return InvitationContextResponseEnterpriseKpiFromJSONTyped(json, false);
}

export function InvitationContextResponseEnterpriseKpiFromJSONTyped(json: any, ignoreDiscriminator: boolean): InvitationContextResponseEnterpriseKpi {
    if (json == null) {
        return json;
    }
    return {
        
        'displayKpi': json['displayKpi'] == null ? undefined : json['displayKpi'],
        'ageInYears': json['ageInYears'] == null ? undefined : json['ageInYears'],
        'ageInMonths': json['ageInMonths'] == null ? undefined : json['ageInMonths'],
        'nbCompletedMissions': json['nbCompletedMissions'] == null ? undefined : json['nbCompletedMissions'],
    };
}

export function InvitationContextResponseEnterpriseKpiToJSON(value?: InvitationContextResponseEnterpriseKpi | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'displayKpi': value['displayKpi'],
        'ageInYears': value['ageInYears'],
        'ageInMonths': value['ageInMonths'],
        'nbCompletedMissions': value['nbCompletedMissions'],
    };
}

